// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Ddmm","empty":"ModalGraph_empty__37veQ"};